import { createContext } from "react";

export const UpcsContext = createContext();
export const UpcsProvider = UpcsContext.Provider;
export const UpcsConsumer = UpcsContext.Consumer;

export const ShipmentContext = createContext();
export const ShipmentProvider = ShipmentContext.Provider;
export const ShipmentConsumer = ShipmentContext.Consumer;
